import { HygienistJobInfoItem } from './HygienistHome.types';

export type HygienistDisplayInfo = {
  isToday: boolean;
  isPast: boolean;
  statusClass: string;
  hasAction: boolean;
  jobCount: number;
  shouldShowIndicators: boolean;
  /** @deprecated use expiredOfferCount instead. */
  hasExpiredOffer?: boolean;
  /** Total count of expired offers on this date (PartialOffer.status === 3). */
  expiredOfferCount?: number;
  /** Count of viewable available shifts on this date (green/white badge). */
  availableShiftCount?: number;
  /** True when available shifts exist but are inside a cancellation-penalty window. */
  isPenaltyBlocked?: boolean;
  /** Count of active (status 0) partial offers on this date (yellow badge). */
  activeOfferCount?: number;
  /** Purple Auto-book schedule marker from DailySettings. */
  showAutobookSchedule?: boolean;
};

export const isDateToday = (date: Date): boolean => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isPastDate = (date: Date): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const cmp = new Date(date);
  cmp.setHours(0, 0, 0, 0);
  return cmp < today;
};

// Placeholder mapping. Will be replaced by hygienist status logic once data is wired
export const getHygienistDateDisplayInfo = (
  date: Date,
  jobs: HygienistJobInfoItem[]
): HygienistDisplayInfo => {
  const isTodayFlag = isDateToday(date);
  const isPastFlag = isPastDate(date);
  const jobCount = jobs?.length || 0;
  const hasAction = false;
  // Status class is computed in hook and injected via MonthView's getDisplayInfo strategy.
  // Fallback to no status here.
  const statusClass = '';
  const shouldShowIndicators = jobCount > 0;
  return {
    isToday: isTodayFlag,
    isPast: isPastFlag,
    statusClass,
    hasAction,
    jobCount,
    shouldShowIndicators,
  };
};


